import ConfigStepPause from "../configuration/config/ConfigStepPause";
import ConfigStepMscore from "../configuration/config/ConfigStepMscore";
import EQPauseStepConfig from "../../public-apis/onclick/EQPauseStepConfig";
import EQmScoreStepConfig from "../../public-apis/onclick/EQmScoreStepConfig";

/**
 * Create step executor from config
 */
export default class StepConfigFactory {

    /**
     * Transform an internal config to public config
     * @param {ConfigStepPause | ConfigStepMscore} stepConfig to transform
     * @return {EQPauseStepConfig | EQmScoreStepConfig | null} null if config type not supported
     */
    static getStepPublicConfig(stepConfig) {
        if (stepConfig instanceof ConfigStepPause) {
            return new EQPauseStepConfig(stepConfig.pause);
        } else if (stepConfig instanceof ConfigStepMscore) {
            return new EQmScoreStepConfig(stepConfig.getDirection(), stepConfig.getSocketCount(), stepConfig.getService(), stepConfig.getModule(), stepConfig.getTimeout(), stepConfig.getParams());
        }

        return null;
    }
}


// WEBPACK FOOTER //
// ./js/core/script/StepConfigFactory.js